// extracted by mini-css-extract-plugin
export var textInput = "_jf-0";